import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { BrandedButton } from "./BrandedButton";

interface BrandedResultMessageProps {
  title: string;
  message: string;
  primaryLabel: string;
  onPrimary: () => void;
}

// Fundo/texto do bloco de sucesso, derivados do token semântico `success` do tema (sem hex).
// Tinta leve (12%) de success.main + texto success.dark garantem contraste AA (>= 4.5:1),
// ao contrário de contrastText (branco) sobre success.light.
export const SUCCESS_BLOCK_ALPHA = 0.12;
export const SUCCESS_BLOCK_FG = "success.dark" as const;

// Estado de sucesso das telas Branded: título + bloco de destaque com a cor semântica
// `success` do tema + botão primário de retorno. Cobre "Confira seu e-mail",
// "Senha cadastrada", "Senha atualizada". Cores vêm do tema; sem hex, sem literal de marca.
export const BrandedResultMessage: React.FC<BrandedResultMessageProps> = ({
  title,
  message,
  primaryLabel,
  onPrimary,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <Typography variant="h2" color="primary" sx={{ fontSize: "2.2rem", fontWeight: 700 }}>
      {title}
    </Typography>
    <Box
      role="status"
      sx={{
        bgcolor: (theme) => alpha(theme.palette.success.main, SUCCESS_BLOCK_ALPHA),
        color: SUCCESS_BLOCK_FG,
        borderRadius: 1,
        p: 2,
        fontSize: "1.4rem",
        lineHeight: 1.5,
      }}
    >
      {message}
    </Box>
    <BrandedButton onClick={onPrimary}>{primaryLabel}</BrandedButton>
  </Box>
);
